import { ActionTypes } from "../constants";

var initialState = {
  portfolioDetails: {},
  portfolio: {
    investmentDetails: {
      funds: [],
      sips: [],
      timeline: []
    },
    investmentSummary: {}
  },
  isLoaded: false,
  isSummaryLoaded: false,
  isLoadedTimeline: false
}

export default function portfolio(state = initialState, action) {
  switch(action.type) {
    case ActionTypes.SET_PORTFOLIO:
      // console.log("~~~ set portfolio ~~~");
      // console.log("reducer States:", state);
      return Object.assign({}, state, action.payload);
    case ActionTypes.CLEAR_PORTFOLIO:
      return {};
    default:
      return state;
  }
}